import loginUser from '@/utils/login-user'

export default async function ({ store, route, redirect }) {
  if (process.server) return
  await loginUser(store, route.path, redirect)
}
